import {
  Clock,
  MapPin,
  ToggleLeft,
  ToggleRight,
  User,
  UsersRound,
} from "lucide-react";
import { deletepost, post } from "../../services/Mainservice";
import "../../assets/Styles/Post.css";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Loader from "../../Loader/Loader";
import Pagination from "../../components/common/pagination";

const Posts = () => {
  const [loading, setloading] = useState(true);
  const [data, setData] = useState([]);
  const [deleted, setdeleted] = useState(false);
  const [pagination, setpagination] = useState({ page: 1 });

  const navigate = useNavigate();

  useEffect(() => {
    getData("1");
  }, []);

  useEffect(() => {
    getData("1");
  }, [deleted]);

  const getData = async (page) => {
    setloading(true);
    try {
      const response = await post(page, deleted);
      setData(response.data.data);
      setpagination(response.data.pagination);

      setloading(false);
    } catch (error) {
      setloading(false);
      if (error.status === 401) {
        localStorage.clear();
        navigate("/");
      }
    }
  };
  const handledelete = async (id) => {
    console.log(id);
    try {
      const response = await deletepost(id);
      getData();
    } catch (error) {
      setloading(false);
      if (error.status === 401) {
        localStorage.clear();
        navigate("/");
      }
    }
  };

  return (
    <>
      <div className="data_head">
        <h1 className="data_heading">Post List</h1>
        <p className="data_subheading">
          Deleted Only{" "}
          {deleted ? (
            <ToggleRight
              size={30}
              onClick={() => setdeleted(false)}
              style={{ cursor: "pointer" }}
            />
          ) : (
            <ToggleLeft
              onClick={() => setdeleted(true)}
              size={30}
              style={{ color: "var(--pink)", cursor: "pointer" }}
            />
          )}
        </p>
      </div>
      <div className="post_list">
        {data.length > 0 ? (
          <>
            {data?.map((item) => (
              <div className="post_card">
                <img src={item.image} className="post_card_image" />
                <p>
                  <span style={{ fontFamily: "bold" }}>{item.Title} </span>
                </p>
                <p className="post_info_icon">
                  <UsersRound
                    style={{
                      color: "var(--white)",
                      strokeWidth: "1.3px",
                    }}
                  />
                  {item.GroupSize}
                </p>
                <div className="post_info_icon">
                  <p className="post_info_icon">
                    <MapPin
                      style={{ color: "var(--white)", strokeWidth: "1.3px" }}
                    />
                    {item.Location.length > 16
                      ? item.Location.slice(0, 13) + "..."
                      : item.Location}
                  </p>
                  <p className="post_info_icon">
                    <Clock
                      style={{ color: "var(--white)", strokeWidth: "1.3px" }}
                    />
                    {item.Time}
                  </p>
                </div>
                <div className="post_button_list">
                  {" "}
                  <button
                    className="post_button"
                    onClick={() =>
                      navigate("/Post_Details", {
                        state: {
                          id: item.id,
                        },
                      })
                    }
                  >
                    View Details
                  </button>
                  <button
                    className="post_button"
                    onClick={() => handledelete(item.id)}
                  >
                    Delete Post
                  </button>
                </div>
              </div>
            ))}
          </>
        ) : (
          <p className="nodata">No Post Available</p>
        )}
      </div>
      <div style={{ width: "58%", margin: "10px 0" }}>
        {" "}
        <Pagination pagedata={pagination} onPageChange={getData} />
      </div>
      {loading && <Loader />}
    </>
  );
};
export default Posts;
